export default "__VITE_PUBLIC_ASSET__5444977c__"